import { Tokens } from "../../sharedTypes/Tokens";
export var FooterText;
(function (FooterText) {
    FooterText["SOFTWARE"] = "Meal Delivery Software by MealTrack";
    FooterText["PRIVACY"] = "Privacy Policy";
})(FooterText || (FooterText = {}));
export const PRIVACY_LINK = "https://mealtrack.com/privacy-policy";
export const replaceCompanyName = (footerAttributionMD, displayName) => {
    const markdownLinkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
    const replacement = markdownLinkRegex.test(footerAttributionMD) ? encodeURIComponent(displayName) : displayName;
    return footerAttributionMD.replace(Tokens.CompanyName, replacement);
};
